import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { useApi, API } from "@/lib/api";

export default function CustomerPhotos() {
  const { t } = useLang();
  const { data } = useApi("/review-photos-gallery");
  if (!data?.length) return null;
  return (
    <section data-testid="customer-photos-section" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{t("photos_title")}</h2>
      <p className="mt-2 text-base text-slate-500">{t("photos_sub")}</p>
      <div className="mt-8 columns-2 gap-4 md:columns-3 lg:columns-4">
        {data.map((p) => (
          <Link key={p.path} to={`/destinations/${p.destination_slug}`} data-testid={`customer-photo-${p.review_id}`} className="group relative mb-4 block break-inside-avoid overflow-hidden rounded-2xl">
            <img src={`${API}/review-photos/${p.path}`} alt={p.destination_name} loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-3 text-white">
              <p className="flex items-center gap-1 text-xs"><Star className="h-3 w-3 fill-amber-400 text-amber-400" />{p.rating} · {p.user_name}{p.country ? ` · ${p.country}` : ""}</p>
              <p className="text-sm font-bold">{p.destination_name}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
